import { useState } from 'react';
import { httpClient } from '../api/http';
import { Alert } from '@piggytechng/component-library';

const useWebhooks = () => {
  const [isLoading, setIsLoading] = useState({
    repushWebhooks: false,
  });

  const repushWebhooks = async (sessionId: string, callback?: () => void) => {
    try {
      setIsLoading((prev) => ({ ...prev, repushWebhooks: true }));
      const response = await httpClient.post<any>('/admin/site-configuration/payment-processor/repush-webhooks', {
        sessionId,
      });

      if (response.data?.status) {
        Alert.success(response.data.message || 'Webhook repushed successfully');
        callback && callback();
        return response.data;
      } else {
        Alert.error(response.data?.message || 'Failed to repush webhook');
        return Promise.reject(response.data);
      }
    } catch (error: any) {
      console.error('Repush Webhook Error:', error);
      return error;
    } finally {
      setIsLoading((prev) => ({ ...prev, repushWebhooks: false }));
    }
  };

  return {
    isLoading,
    repushWebhooks,
  };
};

export default useWebhooks;
